import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { Router } from "@angular/router";
import { Subscription } from "rxjs";
import { IAdminSystemAlert } from "../../../Utils/_models/notification.model";
import {
  ADMIN_NOTIFICATIONS_ROUTE,
  NotificationCenterService,
} from "../../../Utils/_services/admin/notifications/notification-center.service";

const AUTO_DISMISS_MS = 6000;

@Component({
  selector: "app-notification-popup",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./notification-popup.component.html",
  styleUrl: "./notification-popup.component.css",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationPopupComponent implements OnInit, OnDestroy {
  alert: IAdminSystemAlert | null = null;
  leaving = false;

  private sub?: Subscription;
  private dismissTimer?: ReturnType<typeof setTimeout>;

  constructor(
    private notificationCenter: NotificationCenterService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.sub = this.notificationCenter.popupAlert$.subscribe((alert) => {
      this.alert = alert;
      this.leaving = false;
      this.cdr.markForCheck();
      this.scheduleDismiss();
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
    this.clearTimer();
  }

  get typeLabel(): string {
    switch (this.alert?.type) {
      case "security_login":
        return "Security Login";
      case "billing":
        return "Billing";
      case "system_alert":
        return "System Alert";
      default:
        return "Notification";
    }
  }

  onOpen(): void {
    this.dismiss();
    this.router.navigate([ADMIN_NOTIFICATIONS_ROUTE]);
  }

  onDismiss(event?: Event): void {
    event?.stopPropagation();
    this.dismiss();
  }

  private scheduleDismiss(): void {
    this.clearTimer();
    this.dismissTimer = setTimeout(() => this.dismiss(), AUTO_DISMISS_MS);
  }

  private clearTimer(): void {
    if (this.dismissTimer) {
      clearTimeout(this.dismissTimer);
      this.dismissTimer = undefined;
    }
  }

  /** Plays the exit transition, then tears the popup down. */
  private dismiss(): void {
    if (!this.alert || this.leaving) return;

    this.clearTimer();
    this.leaving = true;
    this.cdr.markForCheck();
    setTimeout(() => {
      this.alert = null;
      this.leaving = false;
      this.cdr.markForCheck();
    }, 220);
  }
}
